import { addSkillLikeMapping, listFiles, rel } from '../import-map-shared.js';
import {
  DEEPAGENTS_CLI_ROOT_FILE,
  DEEPAGENTS_CLI_SKILLS_DIR,
  DEEPAGENTS_CLI_MCP_FILE,
  DEEPAGENTS_CLI_GLOBAL_ROOT_FILE,
  DEEPAGENTS_CLI_GLOBAL_SKILLS_DIR,
  DEEPAGENTS_CLI_GLOBAL_MCP_FILE,
} from '../../../targets/deepagents-cli/constants.js';
import type { TargetLayoutScope } from '../../../targets/catalog/target-descriptor.js';
import { AB_RULES } from './constants.js';

export async function buildDeepagentsCliImportPaths(
  refs: Map<string, string>,
  projectRoot: string,
  scope: TargetLayoutScope = 'project',
): Promise<void> {
  if (scope === 'global') {
    refs.set(DEEPAGENTS_CLI_GLOBAL_ROOT_FILE, `${AB_RULES}/_root.md`);
    for (const absPath of await listFiles(projectRoot, DEEPAGENTS_CLI_GLOBAL_SKILLS_DIR)) {
      addSkillLikeMapping(refs, rel(projectRoot, absPath), DEEPAGENTS_CLI_GLOBAL_SKILLS_DIR);
    }
    refs.set(DEEPAGENTS_CLI_GLOBAL_MCP_FILE, '.agentsmesh/mcp.json');
    return;
  }

  refs.set(DEEPAGENTS_CLI_ROOT_FILE, `${AB_RULES}/_root.md`);
  for (const absPath of await listFiles(projectRoot, DEEPAGENTS_CLI_SKILLS_DIR)) {
    addSkillLikeMapping(refs, rel(projectRoot, absPath), DEEPAGENTS_CLI_SKILLS_DIR);
  }
  refs.set(DEEPAGENTS_CLI_MCP_FILE, '.agentsmesh/mcp.json');
}
